export default __webpack_public_path__ + "static/media/kanit-regular.9a510f7c.eot";